import getTranslationsByLocale from '~/common/utils/getTranslations';
import { GET_TRANSLATIONS } from '../types';

const initialState = {
  common: {},
  addCar: {
    registrationInfo: {},
    errorMessages: {},
    vinAndOdometer: {},
    uploadDocuments: {},
  },
  removeCar: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSLATIONS:
      return {
        ...state,
        ...getTranslationsByLocale(action.payload),
      };
    default:
      return state;
  }
};
